module.exports = __webpack_public_path__ + "img/The_Sign.247f0759.jpg";